module.exports = __webpack_public_path__ + "img/mob-circle-3.d6047397.png";